const inputClass =
  "p-3 rounded-lg bg-bg-soft border border-border w-full text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent transition";

export default function DBFields({
  type,
  isTarget,
  dbName,
  setDbName,
  collection,
  setCollection,
  apiKey,
  setApiKey,
  url,
  setUrl,
  batchSize,
  setBatchSize,
  embeddingField,
  setEmbeddingField,
}) {
  return (
    <div className="grid gap-4 w-full">

      {/* -------------------------------------- */}
      {/*            PINECONE FIELDS             */}
      {/* -------------------------------------- */}
      {type === "pinecone" && (
        <>
          <input
            type="text"
            placeholder="Index Name (e.g., source-pinecone)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Pinecone API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Environment / Host URL (e.g. https://xyz.pinecone.io)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

      {/* -------------------------------------- */}
      {/*               MILVUS FIELDS            */}
      {/* -------------------------------------- */}
      {type === "milvus" && (
        <>
          <input
            type="text"
            placeholder="Collection Name (e.g., source_milvus)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Milvus Token"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Milvus URI (e.g., https://your-instance.milvus.io)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

      {/* -------------------------------------- */}
      {/*               QDRANT FIELDS            */}
      {/* -------------------------------------- */}
      {type === "qdrant" && (
        <>
          <input
            type="text"
            placeholder="Collection Name (e.g., source_qdrant)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Qdrant API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Qdrant URL (https://host:6333)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

      {/* -------------------------------------- */}
      {/*               CHROMA FIELDS            */}
      {/* -------------------------------------- */}
      {type === "chroma" && (
        <>
          <input
            type="text"
            placeholder="Collection Name (e.g., source_chroma)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Database Name (e.g., source_chroma)"
            value={dbName}
            onChange={(e) => setDbName(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Chroma API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Tenant ID / Host URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

      {/* -------------------------------------- */}
      {/*              WEAVIATE FIELDS           */}
      {/* -------------------------------------- */}
      {type === "weaviate" && (
        <>
          <input
            type="text"
            placeholder="Class Name (e.g., Weaviate_db)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Weaviate API Key"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Weaviate Cloud URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

      {/* -------------------------------------- */}
      {/*              MONGODB FIELDS            */}
      {/* -------------------------------------- */}
      {type === "mongo" && (
        <>
          <input
            type="text"
            placeholder="Collection Name (e.g., vectors)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Database Name (e.g., vector_db)"
            value={dbName}
            onChange={(e) => setDbName(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="MongoDB URI (e.g., mongodb+srv://user:pass@cluster.mongodb.net)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Embedding Field Name (default: embeddings)"
            value={embeddingField}
            onChange={(e) => setEmbeddingField(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional, default: 100)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

      {/* -------------------------------------- */}
      {/*             PGVECTOR FIELDS            */}
      {/* -------------------------------------- */}
      {type === "pgvector" && (
        <>
          <input
            type="text"
            placeholder="Table Name (e.g., embeddings_table)"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="PostgreSQL Connection String (e.g., postgresql://user:pass@host:5432/dbname)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className={inputClass}
          />
          <input
            type="text"
            placeholder="Vector Column Name (default: embedding)"
            value={embeddingField}
            onChange={(e) => setEmbeddingField(e.target.value)}
            className={inputClass}
          />
          {!isTarget && (
            <input
              type="number"
              placeholder="Batch Size (optional, default: 100)"
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className={inputClass}
            />
          )}
        </>
      )}

    </div>
  );
}